






















import { Component, Vue } from "vue-property-decorator";

@Component
class ModalMixinBindRequire extends Vue {
  bindAvaliable = true;

  get dialog() {
    const currentPageNeedMixinBind = this.$store.state.app
      .currentPageNeedMixinBind;
    const isMixinBinded = this.$store.getters["basis/account/isMixinBinded"];
    const hasProfile = this.$store.state.basis.account.profile;
    return currentPageNeedMixinBind && hasProfile && !isMixinBinded;
  }

  handleOK() {
    this.$common.utils.helper.requestBindMixin(this);
  }

  handleLogout() {
    this.$common.utils.helper.requestLogout(this);
  }
}
export default ModalMixinBindRequire;
